import styled from "styled-components";

export const Title = styled.h2`
  margin-bottom: 20px;
`;

export const Header = styled.section`
  display: flex;
  align-items: center;
`;

export const Status = styled.div`
  height: 25px;
  margin: 5px 0 0 10px;
`;

export const Section = styled.div`
  margin-top: 30px;
`;

export const SectionTitle = styled.h3`
  margin-bottom: 10px;
  font-size: 17px;
`;

export const SectionContent = styled.div`
  margin: 0 0 5px;
  line-height: 22px;
`;

export const Label = styled.span`
  display: block;
  font-size: 14px;
  color: #adadad;
  font-weight: 700;
`;

export const Result = styled.span`
  font-size: 13px;
  display: block;
`;

export const Container = styled.section`
  padding: 10px 20px;
`;
